import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {RootState} from '../../app/rootReducer'
import {fetchConfigurationPromo} from '../../app/thunk'
import {ConfigurationPromo} from '../../types/configurationPromo'
import {normalizeConfigurationPromo} from '../../shared/configurationPromoDefaults'

export const configurationPromoSlice = createSlice({
    name: 'general',
    initialState: {
        configuration: normalizeConfigurationPromo({
            cta_opening: {
                hide_cta: true,
            },
            coupon: {
                recoverable: false,
            },
        }),
        urlParameters: {},
        requestId: null as string | null,
    },
    reducers: {
        setConfiguration(
            state: RootState,
            action: PayloadAction<ConfigurationPromo>
        ): void {
            state.configuration = action.payload
            state.requestId = null
        },
        setUrlParameters(
            state: RootState,
            action: PayloadAction<object>
        ): void {
            state.urlParameters = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(
                fetchConfigurationPromo.pending,
                (state: RootState, action) => {
                    state.requestId = action.meta.requestId
                }
            )
            .addCase(
                fetchConfigurationPromo.fulfilled,
                (state: RootState, action) => {
                    if (state.requestId === action.meta.requestId) {
                        state.configuration = action.payload
                        state.requestId = null
                    }
                }
            )
            .addCase(
                fetchConfigurationPromo.rejected,
                (state: RootState, action) => {
                    if (state.requestId === action.meta.requestId) {
                        state.requestId = null
                    }
                }
            )
    },
})

export const {setUrlParameters} = configurationPromoSlice.actions

export default configurationPromoSlice.reducer
